<template>
  <div class="flex self-end">
    <div class="flex gap-2 items-center">
      <UiCSpinner v-if="loading" class="mr-2" />
      <div>
        <label class="sr-only" for="order-by-select">Order-by</label>
        <c-dropdown
          id="order-by-select"
          v-model="computedOrderBy"
          :options="orderByOptions"
        />
      </div>

      <div>
        <label class="sr-only" for="direction-select">Direction</label>
        <c-dropdown
          id="direction-select"
          v-model="computedDirection"
          :options="directionOptions"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {computed, toRefs} from '#imports';
  import CDropdown from '~/components/ui/CDropdown.vue';

  const props = withDefaults(
    defineProps<{
      orderBy?: string;
      direction?: string | null;
      loading?: boolean;
    }>(),
    {
      orderBy: 'name',
      direction: 'asc',
      loading: false,
    },
  );

  const {orderBy, direction} = toRefs(props);

  const emit = defineEmits([
    'update:orderBy',
    'update:direction',
    'orderByChange',
  ]);

  const computedOrderBy = computed({
    get: () => orderBy.value,
    set: (newValue) => {
      emit('update:orderBy', newValue);
      emit('orderByChange');
    },
  });

  const computedDirection = computed({
    get: () => direction.value,
    set: (newValue) => {
      emit('update:direction', newValue);
      emit('orderByChange');
    },
  });

  const orderByOptions = computed(() => {
    return [
      {label: 'Popularity', value: 'popularity'},
      {label: 'Rating', value: 'ratingAvg'},
      {label: 'Last Update', value: 'dateUpdated'},
      {label: 'Total Reviews', value: 'totalReviews'},
      {label: 'Name', value: 'name'},
    ];
  });

  const directionOptions = computed(() => {
    return [
      {label: 'Ascending', value: 'asc'},
      {label: 'Descending', value: 'desc'},
    ];
  });
</script>
